<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.6376 13.6833C12.9042 13.9333 12.9042 14.3667 12.6542 14.6333C12.5209 14.7667 12.3542 14.8334 12.1709 14.8334C12.0042 14.8334 11.8376 14.7667 11.7042 14.65L7.37089 10.4833C7.23756 10.35 7.1709 10.1834 7.1709 10C7.1709 9.81668 7.23756 9.65002 7.37089 9.51669L11.7042 5.35002C11.9709 5.10002 12.3876 5.10002 12.6542 5.36669C12.9042 5.63335 12.9042 6.05002 12.6376 6.31668L8.80424 10L12.6376 13.6833Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: "chevronLeft",
    props: {
      fill: {
        type: String,
        default: 'white'
      }
    }
  }
</script>

<style scoped>

</style>
